import { faEye } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AdvanceTable from 'components/common/advance-table/AdvanceTable'
import CardDropdown from 'components/common/CardDropdown'
import FalconPagination from 'components/common/custom/pagination'
import useAdvanceTable from 'hooks/useAdvanceTable'
import moment from 'moment'
import AdvanceTableProvider from 'providers/AdvanceTableProvider'
import React, { useEffect } from 'react'
import { Card, Dropdown } from 'react-bootstrap'
import { Gear } from 'react-bootstrap-icons'

import { useDispatch } from 'react-redux'
import { ViewSingleClaimPoll } from '../config/ClaimPollsApi'
import { toast } from 'react-toastify'

const ClaimPollsTable = ({
    data,
    totalRows,
    page,
    rowsPerPage,
    handlePageChange,
    handlePerRowsChange
}) => {
    const dispatch = useDispatch();
    const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];

    const handleViewPoll = (original) => {
        const body = {
            polls_id: original?.polls_id,
            polls_type: original?.polls_type
        };

        dispatch(ViewSingleClaimPoll(body)).unwrap().then((data) => {
            if (data?.success) {
                const fileUrl = data?.data?.[0]?.pollresp_path;
                if (fileUrl) {
                    window.open(fileUrl, "_blank");
                } else {
                    toast.error("No viewable file found in response");
                }
            }
        })
    }


    const columns = [
        {
            accessorKey: "index",
            header: "#",
            cell: ({ row }) => (
                <div className="d-flex align-items-center w-100">
                    <div
                        className="rounded-circle bg-200 d-flex flex-center fs-11"
                        style={{ width: "30px", height: "30px" }}
                    >
                        {page * rowsPerPage + row.index + 1}
                    </div>
                </div>
            ),
        },
        {
            accessorKey: "branch_id",
            header: "Branch Name",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {allBranches?.find((branch) => branch?.branch_id === original?.branch_id)?.branch_name}
                </div>
            ),
        },
        {
            accessorKey: "created_at",
            header: "Create Date",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.created_at ? moment(original?.created_at).format("DD-MM-YYYY hh:mm:ss A") : ""}
                </div>
            ),
        },
        {
            accessorKey: "polls_id",
            header: "Polls ID",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.polls_id}
                </div>
            ),
        },
        {
            accessorKey: "polls_type",
            header: "Polls Type",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.polls_type}
                </div>
            ),
        },
        {
            accessorKey: "polls_descp",
            header: "Polls Desc.",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.polls_descp}
                </div>
            ),
        },
        {
            accessorKey: "totalpolls_resp",
            header: "Total Polls Response",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.totalpolls_resp}
                </div>
            ),
        },
        {
            accessorKey: "totalpolls_req",
            header: "Total Polls Request",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.totalpolls_req}
                </div>
            ),
        },
        {
            accessorKey: "actions",
            header: <Gear />,
            enableSorting: false,
            cell: ({ row: { original } }) => {
                return (
                    <CardDropdown
                        icon="ellipsis-v"
                        dropdownClassName="py-2 custom-dropdown-menu"
                    >
                        <Dropdown.Item
                            onClick={() => handleViewPoll(original)}
                        >
                            <FontAwesomeIcon icon={faEye} className="me-2" />
                            View Claim Poll
                        </Dropdown.Item>
                    </CardDropdown>
                )
            }
        }
    ]

    const table = useAdvanceTable({
        data,
        columns,
        manualPagination: true,
        pageCount: Math.ceil(totalRows / rowsPerPage),
        state: {
            pagination: {
                pageIndex: page,
                pageSize: rowsPerPage,
            },
        },
    });

    useEffect(() => {
        table.setPagination({ pageIndex: page, pageSize: rowsPerPage });
    }, [page, rowsPerPage]);

    return (
        <div className='mb-3 mt-3 border'>
            {data?.length > 0 ? (
                <>
                    <AdvanceTableProvider {...table}>
                        <AdvanceTable
                            tableProps={{
                                size: "sm",
                                className: "fs-10 mb-0 overflow-hidden",
                                striped: true,
                                hover: true,
                            }}
                            headerClassName="bg-200 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                        />
                    </AdvanceTableProvider>
                    <Card.Footer className="d-flex mt-2 mb-3 justify-content-end align-items-center">
                        <FalconPagination
                            currentPage={page}
                            rowsPerPage={rowsPerPage}
                            totalRecords={totalRows}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePerRowsChange}
                        />
                    </Card.Footer>
                </>
            ) : (
                <div className="text-center py-3">No Data To Show</div>
            )}
        </div>
    )
}

export default ClaimPollsTable